'use client';

import { useState, useEffect } from 'react';
import ServiceSelector from './ServiceSelector';
import PricingComparison from './PricingComparison';
import DisclaimerSection from './DisclaimerSection';
import CTASection from './CTASection';

interface ServiceSelection {
  serviceType: string;
  vehicleBrand: string;
  vehicleYear: string;
  vehicleModel: string;
}

const PriceCompareInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selection, setSelection] = useState<ServiceSelection>({
    serviceType: '',
    vehicleBrand: '',
    vehicleYear: '',
    vehicleModel: ''
  });

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleServiceChange = (newSelection: ServiceSelection) => {
    if (isHydrated) {
      setSelection(newSelection);
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
          <div className="animate-pulse space-y-6">
            <div className="h-48 bg-muted rounded-xl" />
            <div className="h-96 bg-muted rounded-xl" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <ServiceSelector onServiceChange={handleServiceChange} />
      <PricingComparison 
        serviceType={selection.serviceType} 
        vehicleBrand={selection.vehicleBrand} 
      />
      <DisclaimerSection />
      <CTASection />
    </div>
  );
};

export default PriceCompareInteractive;